import { Switch } from "@mantine/core";
import { memo, useCallback, useMemo } from "react";
import { Flex, StyledTd, StyledTr } from "src/styled";
import { deepClone } from "src/utils";

import type { IUser } from "./UserList.types";

interface Props {
  user: IUser;
  onUserSelect: (user: IUser) => void;
  showRotationChange: boolean;
  changedUsers: IUser[];
  setChangedUsers: (value: IUser[]) => void;
}

const UserListRow = ({
  user,
  onUserSelect,
  showRotationChange,
  changedUsers,
  setChangedUsers,
}: Props) => {
  const handleSwitchChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.checked;
      const usersCopy: IUser[] = deepClone(changedUsers);

      const findIndex = usersCopy.findIndex(
        ({ userid }) => userid === user.userid,
      );

      if (findIndex !== -1) usersCopy[findIndex].newActiveValue = value;
      else usersCopy.push({ ...user, newActiveValue: value });

      setChangedUsers(usersCopy);
    },
    [user, changedUsers, setChangedUsers],
  );

  const handleRowClick = useCallback(
    (event: React.MouseEvent<HTMLTableRowElement>) => {
      if (!(event.target as any).closest(".mantine-Switch-root")) {
        onUserSelect(user);
      }
    },
    [user, onUserSelect],
  );

  const switchValue = useMemo(() => {
    const changedUser = changedUsers.find(u => u.userid === user.userid);
    return changedUser ? changedUser.newActiveValue : Boolean(user.active);
  }, [user, changedUsers]);
  return (
    <StyledTr hover pointer key={user.userid} onClick={handleRowClick}>
      <StyledTd>{user.extref ?? ""}</StyledTd>
      <StyledTd>{user.firstname}</StyledTd>
      <StyledTd>{user.surname}</StyledTd>
      <StyledTd style={{ textAlign: "center" }}>{user.ref}</StyledTd>
      <StyledTd>{user.rolename}</StyledTd>
      <StyledTd>{user.email}</StyledTd>
      <StyledTd style={{ textAlign: "center" }}>
        {user.active ? "Yes" : "No"}
      </StyledTd>
      {showRotationChange && (
        <StyledTd style={{ textAlign: "center" }}>
          <Flex align="center" justify="center">
            <Switch checked={switchValue} onChange={handleSwitchChange} />
          </Flex>
        </StyledTd>
      )}
    </StyledTr>
  );
};
export default memo(UserListRow);
